//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    mounted () {
        this.$store.commit('hideHTMLElements');
    },

    destroyed () {
        this.$store.commit('showHTMLElements');
    },

    methods: {
        logout () {
            window.location.href = '/logout';
        }
    }
};
